// Reset Account Password
export const RESET_ACCOUNT_PASSWORD_REQUEST = 'RESET_ACCOUNT_PASSWORD_REQUEST';
export const RESET_ACCOUNT_PASSWORD_DONE = 'RESET_ACCOUNT_PASSWORD_DONE';
export const RESET_ACCOUNT_PASSWORD_FAILED = 'RESET_ACCOUNT_PASSWORD_FAILED';
export const RESET_ACCOUNT_PASSWORD_RESET = 'RESET_ACCOUNT_PASSWORD_RESET';